import { NotFoundFallback } from "@shared/ui";

export function NotFoundPage() {
  return (
    <NotFoundFallback status={404} className="base-error-page-wrapper--viewport" />
  );
}
